export function useTabbedSections() {
  function TabbedSections(ts) {
    if (!(ts instanceof Element)) {
      return;
    }

    const btns = ts.querySelectorAll(".tabbed-sections__button");
    const sections = ts.querySelectorAll(".tabbed-sections__section");
    const wrapper = ts.querySelector(".tabbed-sections__wrap");

    function setHeight(target) {
      const height = target.offsetHeight;
      wrapper.setAttribute("style", `--height: ${height}px`);
    }

    async function deactivateAll() {
      btns.forEach((btn) => btn.classList.remove("active"));
      sections.forEach((section) => section.classList.remove("transitioned"));
      await wait(200);
      sections.forEach((section) => {
        section.classList.remove("active");
        section.setAttribute("aria-expanded", "false");
      });
    }

    async function activateTab(target) {
      target.classList.add("active");
      setHeight(target);
      await wait(200);
      target.classList.add("transitioned");
      target.setAttribute("aria-expanded", "true");
    }

    async function handleBtnClick(e, btn) {
      e.preventDefault();
      deactivateAll();
      await wait(200);
      btn.classList.add("active");
      const targetRef = btn.getAttribute("href");
      const target = ts.querySelector(targetRef);
      activateTab(target);
      window.history.pushState("", "", targetRef);
    }

    async function updateTabOnLoad() {
      let initialTab = false;
      const initialTabRef = window.location.hash;

      if (initialTabRef) {
        initialTab = ts.querySelector(initialTabRef);
      }

      if (initialTab && initialTab !== sections[0]) {
        deactivateAll();
        await wait(200);
        activateTab(initialTab);
        btns.forEach((btn) => {
          if (btn.getAttribute("href") === window.location.hash) {
            btn.classList.add("active");
          }
        });
      } else {
        setHeight(sections[0]);
      }
    }

    updateTabOnLoad();
    btns.forEach((btn) =>
      btn.addEventListener("click", (e) => handleBtnClick(e, btn))
    );
  }

  const tabbedSections = document.querySelectorAll(".tabbed-sections");

  tabbedSections.forEach((ts) => TabbedSections(ts));
}
